/* __next_internal_client_entry_do_not_use__ SDUIProductTileWithBrand auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { VERTICAL_PRODUCT_TILE_CATEGORY_PATH_IDS } from "@faire/retailer-shared/categories/verticalProductTileCategoryPathIds";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import React, { useMemo } from "react";
import { useSDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/ActionHandler/useSDUIOnClickHandler";
import { useGenerateBrandUrlForSDUIProductTileHandler, useGenerateProductLinkPropsForSDUIProductTileHandler } from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/SDUIProductTileUrlHandler";
import { shouldShowPromotedBadge } from "@faire/retailer/features/ADS/util";
import { MarketplaceProduct } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/MarketplaceProduct";
export var SDUIProductTileWithBrand = function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData;
    var _product_product, _product_product1;
    var on_click = tileElement.on_click;
    var _tileElement_product_with_brand_info_tile;
    var _ref = (_tileElement_product_with_brand_info_tile = tileElement.product_with_brand_info_tile) !== null && _tileElement_product_with_brand_info_tile !== void 0 ? _tileElement_product_with_brand_info_tile : {}, product = _ref.product, brand = _ref.brand;
    var brandTile = useMemo(function() {
        return ILeanProductTile.IBrand.build(_object_spread({}, brand));
    }, [
        brand
    ]);
    var generateProductLinkProps = useGenerateProductLinkPropsForSDUIProductTileHandler(product, loggingData.view_display_page);
    var generateBrandUrl = useGenerateBrandUrlForSDUIProductTileHandler(product, loggingData.view_display_page);
    var brandClickLoggingData = useMemo(function() {
        return _object_spread_props(_object_spread({}, loggingData), {
            action_instance_identifier: brandTile === null || brandTile === void 0 ? void 0 : brandTile.token
        });
    }, [
        loggingData,
        brandTile
    ]);
    var onBrandClickHandler = useSDUIOnClickHandler(on_click, brandClickLoggingData, {
        logSDUIClickEvent: true,
        logLegacyClickEvent: true
    });
    var onProductClickHandler = useSDUIOnClickHandler(on_click, loggingData, {
        logSDUIClickEvent: true,
        logLegacyClickEvent: true
    });
    var _product_product_promoted_by;
    var showPromotedBadge = shouldShowPromotedBadge(product === null || product === void 0 ? void 0 : (_product_product = product.product) === null || _product_product === void 0 ? void 0 : _product_product.is_promoted, (_product_product_promoted_by = product === null || product === void 0 ? void 0 : (_product_product1 = product.product) === null || _product_product1 === void 0 ? void 0 : _product_product1.promoted_by) !== null && _product_product_promoted_by !== void 0 ? _product_product_promoted_by : []);
    /**
     * This is a temporary solution to show vertical imagery for product tiles
     * in a way that is compatible with RSCs.
     * This should be removed once the BE-driven vertical tile is implemented.
     */ var showVerticalImagery = !!loggingData.view_instance_identifier && VERTICAL_PRODUCT_TILE_CATEGORY_PATH_IDS.includes(loggingData.view_instance_identifier);
    if (product === undefined || brand === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsx(MarketplaceProduct, {
        productTile: product,
        brand: brandTile,
        generateProductLinkProps: generateProductLinkProps,
        generateBrandUrl: generateBrandUrl,
        onClick: onProductClickHandler,
        onBrandClick: onBrandClickHandler,
        recordAdImpression: true,
        shouldShowPromotedBadge: showPromotedBadge,
        showVerticalImagery: showVerticalImagery
    });
};
